export default "__VITE_ASSET__ef280647__"